
import React from 'react';
import { cn } from '@/lib/utils';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
  subtitleClassName?: string;
  gradient?: boolean;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  centered = false,
  className = '',
  subtitleClassName = '',
  gradient = false,
}) => {
  return (
    <div className={cn('mb-12', centered && 'text-center', className)}>
      <h2 
        className={cn(
          'text-3xl md:text-4xl font-ibm-plex font-medium mb-4 tracking-tight',
          gradient && 'text-gradient bg-gradient-to-r from-brand-navy to-brand-teal bg-clip-text text-transparent',
        )}
      >
        {title}
      </h2>
      {subtitle && (
        <p 
          className={cn(
            'text-lg text-gray-600 max-w-3xl font-montserrat',
            centered && 'mx-auto',
            subtitleClassName
          )}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
